import React, { useState } from 'react';
import { Dropdown, Menu } from 'antd';
import countries from 'i18n-iso-countries';
import { useTranslation } from 'react-i18next';
import { languages, LANGUAGE_TO_COUNTRY_CODE_MAP } from 'appConstants';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
// import FlagImage from './FlagImage';
import CountryFlag from 'components/CountryFlag/CountryFlag';
import classNames from 'classnames';
import style from './LanguagePicker.module.scss';

countries.registerLocale(require('i18n-iso-countries/langs/en.json'));
countries.registerLocale(require('i18n-iso-countries/langs/de.json'));
countries.registerLocale(require('i18n-iso-countries/langs/ru.json'));

const LanguagePicker: React.FC = () => {
	const [currentLanguage, setCurrentLanguage] = useState(localStorage.i18nextLng ? localStorage.i18nextLng : 'EN');
	const [open, setOpen] = useState<boolean>(false);

	const arrowClasses = classNames(style.arrow, { [style.arrowActive]: open });

	const { i18n } = useTranslation();

	const toggleOpen = () => {
		setOpen((prevState) => !prevState);
	};

	const changeLanguage = async ({ key }: { key: string }) => {
		await i18n.changeLanguage(key);
		setCurrentLanguage(localStorage.i18nextLng);
		toggleOpen();
	};

	const menu = (
		<Menu className={style.menu}>
			{Object.keys(languages).map((el) => (
				<Menu.Item
					data-test={`dropdown-item-${el}`}
					key={el}
					className={style.menuItem}
					onClick={changeLanguage}>
					<div className={style.itemImgWrapper}>
						{/* <FlagImage countryCode={LANGUAGE_TO_COUNTRY_CODE_MAP[el]} width="40" /> */}
						<CountryFlag countryCode={LANGUAGE_TO_COUNTRY_CODE_MAP[el]} size="24px" />
					</div>
					<span className={style.menuItemLabel}>{languages[el]}</span>
				</Menu.Item>
			))}
		</Menu>
	);

	return (
		<Dropdown overlay={menu} placement="bottomRight" trigger={['click']} onVisibleChange={toggleOpen}>
			<div className={style.iconContainer} data-test="dropdown-lang">
				<div className={style.imgWrapper}>
					{/* <FlagImage countryCode={LANGUAGE_TO_COUNTRY_CODE_MAP[currentLanguage]} width="80" /> */}
					<CountryFlag countryCode={LANGUAGE_TO_COUNTRY_CODE_MAP[currentLanguage]} size="40px" />
				</div>
				<svg className={arrowClasses}>
					<use xlinkHref={`${breadcrumbs}#caretDown`} />
				</svg>
			</div>
		</Dropdown>
	);
};

export default LanguagePicker;
